define([
	"dojo/_base/declare",
	"csi/action/EditController"
], function(declare,EditController) {

	return declare(EditController, {
	});
});